import React from 'react';
import styled from 'styled-components';
import { MdKeyboardArrowDown } from 'react-icons/md';

const InputRow = styled.div`
  margin-bottom: 20px;
`;

const InputTopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  gap: 12px;
`;

const Label = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xsm};
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
  font-family: inherit;
  flex-shrink: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 14px;
  }
`;

const SelectWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 288px;
  position: relative;

  @media (max-width: 768px) {
    width: 150px;
    min-width: 140px;
  }
`;

const StyledSelect = styled.select`
  appearance: none;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  padding-right: 35px;
  border: 1px solid #e2e8f0;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  font-size: ${({ theme }) => theme.typography.fontSizes.md};
  font-weight: ${({ theme }) => theme.typography.fontWeights.bold};
  font-family: inherit;
  background: white;
  cursor: pointer;

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 6px 30px 6px 10px;
    height: 36px;
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

const DownArrow = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-40%);
  pointer-events: none;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 20px;
`;

interface SelectFieldProps {
  label: string;
  value: string | number;
  onChange: (value: string | number) => void;
  options: { value: string | number; label: string }[];
}

export const SelectField: React.FC<SelectFieldProps> = ({ label, value, onChange, options }) => {
  return (
    <InputRow>
      <InputTopRow>
        <Label>{label}</Label>
        <SelectWrapper>
          <StyledSelect value={value} onChange={(e) => onChange(e.target.value)}>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </StyledSelect>
          <DownArrow>
            <MdKeyboardArrowDown />
          </DownArrow>
        </SelectWrapper>
      </InputTopRow>
    </InputRow>
  );
};
